import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-234e0a24"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://d1csarkz8obe9u.cloudfront.net/posterpreviews/abstract-business-logo-template-design-23cfc84c7101787521b1ef2a9bfd1a75_screen.jpg?ts=1561517726",
  width: "50"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Archive ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://cdn.icon-icons.com/icons2/2643/PNG/512/male_boy_person_people_avatar_icon_159358.png" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Unarchive")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_item_option = _resolveComponent("ion-item-option")!
  const _component_ion_item_options = _resolveComponent("ion-item-options")!
  const _component_ion_item_sliding = _resolveComponent("ion-item-sliding")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_base_modal = _resolveComponent("base-modal")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "ion-padding",
        style: {"text-align":"center"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.archiveArray, (person, index) => {
                return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                  key: person.id,
                  style: {"margin-bottom":"5px"},
                  "ion-drag": "set"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(true))),
                      lines: "none",
                      style: _normalizeStyle(index % 2==0 ? '--background: rgba(249, 249, 249)' : '--background: rgba(239, 248, 255)')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_avatar, { slot: "start" }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", null, [
                              _createElementVNode("b", null, _toDisplayString(person.first) + " " + _toDisplayString(person.last), 1)
                            ]),
                            _createElementVNode("p", null, _toDisplayString(person.place), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["style"]),
                    _createVNode(_component_ion_item_options, { side: "end" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item_option, {
                          color: "secondary",
                          id: person.id,
                          onClick: ($event: any) => {this.$store.commit('unarchive', person.id);}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 2
                        }, 1032, ["id", "onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.isOpenRef,
            onOnDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setOpen(false)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_modal, { rootPage: _ctx.ModalHome }, null, 8, ["rootPage"])
            ]),
            _: 1
          }, 8, ["is-open"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}